"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_tracking_1 = require("react-tracking");
var elog = require("../../elog");
var tracker_1 = require("../../tracker");
var qs_1 = require("qs");
var search_input_group_1 = require("../search_input_group");
var url_helpers_1 = require("../../url_helpers");
var SIDEBAR_SECTION = 'sidebar';
var COMPONENT_NAME = 'CategorySearch';
var CategorySearch = /** @class */ (function (_super) {
    tslib_1.__extends(CategorySearch, _super);
    function CategorySearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            query: '',
        };
        _this.search = function (evt) {
            var _a;
            evt.preventDefault();
            var query = (_a = {},
                _a[_this.getQueryParam()] = _this.state.query,
                _a);
            var url;
            if (_this.props.linkOverride) {
                var parts = _this.props.linkOverride.split('?');
                var path = parts[0];
                var existingQuery = qs_1.parse(parts[1]);
                var mergedQuery = qs_1.stringify(tslib_1.__assign(tslib_1.__assign({}, query), existingQuery));
                url = path + "?" + mergedQuery;
            }
            else {
                url = "/marketplace?" + qs_1.stringify(query);
            }
            _this.props.tracking.trackEvent({
                url: url,
                eventType: tracker_1.INTERACTION,
                interactionType: tracker_1.SUBMIT,
                entityId: _this.state.query,
            });
            _this.props.pushPath(url);
        };
        _this.onQueryChange = function (evt) {
            _this.setState({ query: evt.target.value });
        };
        return _this;
    }
    CategorySearch.prototype.getQueryParam = function () {
        if (this.props.isLP)
            return 'sidebar_search';
        return 'query';
    };
    CategorySearch.prototype.getBackgroundImageStyle = function () {
        if (!this.props.imageKey)
            return null;
        return { backgroundImage: "url(" + url_helpers_1.imageUploadURL(this.props.imageKey) + ")" };
    };
    CategorySearch.prototype.getLabelText = function () {
        if (this.props.labelOverride)
            return this.props.labelOverride;
        return I18n.t('cms.categorySearch.searchInCategory', { categoryName: this.props.categoryName });
    };
    CategorySearch.prototype.render = function () {
        try {
            return (React.createElement("div", { className: "cms-search", style: this.getBackgroundImageStyle() },
                React.createElement("div", { className: "cms-search__inner" },
                    React.createElement("label", { className: "cms-search__label" }, this.getLabelText()),
                    React.createElement("div", { className: "cms-search__form" },
                        React.createElement(search_input_group_1.default, { onSubmit: this.search, value: this.state.query, onChange: this.onQueryChange, large: this.props.layoutSection !== SIDEBAR_SECTION, placeholder: this.props.placeholder })))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    CategorySearch.defaultProps = {
        pushPath: function (path) { return window.location.assign(path); },
    };
    CategorySearch = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.SEARCH_TYPE,
                eventType: tracker_1.VIEW,
                context: {
                    linkOverride: props.linkOverride,
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                }
            };
        }, { dispatchOnMount: true })
    ], CategorySearch);
    return CategorySearch;
}(React.Component));
exports.default = CategorySearch;
//# sourceMappingURL=category_search.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/category_search.js
// module id = pUcY
// module chunks = 0 2 6 20